function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM15 28.2C22.2902 28.2 28.2 22.2902 28.2 15C28.2 7.70984 22.2902 1.8 15 1.8C7.70984 1.8 1.8 7.70984 1.8 15C1.8 22.2902 7.70984 28.2 15 28.2ZM8.4 12.0708V20.7949H11.2261V12.0708H8.4ZM9.99882 7.8C9.03204 7.8 8.4 8.45152 8.4 9.30691C8.4 10.1446 9.01336 10.8149 9.96213 10.8149H9.98019C10.9656 10.8149 11.5793 10.1446 11.5793 9.30691C11.561 8.45152 10.9656 7.8 9.99882 7.8ZM18.3462 12.0708C16.8457 12.0708 16.1739 12.9176 15.7988 13.5116V12.2759H12.9725C13.0097 13.0945 12.9725 21 12.9725 21H15.7988V16.1278C15.7988 15.867 15.8172 15.6069 15.8919 15.4202C16.0962 14.8994 16.5612 14.3601 17.342 14.3601C18.365 14.3601 18.774 15.16 18.774 16.3324V20.9998H21.5999L21.6 15.9976C21.6 13.318 20.2058 12.0708 18.3462 12.0708Z",
  fill: "white"
});

var SvgIconLinkedin2 = function SvgIconLinkedin2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLinkedin2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-linkedin2.d9697435.svg";
export { ForwardRef as ReactComponent };